<template>
  <v-container>
    <v-card>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Create Stock Brand Type</v-toolbar-title>
        <v-spacer />
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field v-model="form.name" label="Brand Type Name" outlined dense
                          :error-messages="validationErrors.name" @change="storeToLocal" />
          </v-col>
          <v-col cols="12">
            <v-btn @click="save">
              Save
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/extra-functions/axios.extra'
import LocalStore from '@/lib/localStore'
import { camelToSnake } from '@/lib/utils'
import { ErrorPopup, SuccessPopup } from '../../../../lib/utils'

const defaultForm = () => ({
  name: '',
})

const localStore = new LocalStore({
  schema: {
    createStockBrandType: {
      ...defaultForm(),
      unsavedChanges: false,
    },
  },
})

export default {
  name: 'CreateStockBrandType',
  data() {
    return {
      form: defaultForm(),
      validationErrors: {},
    }
  },
  created() {
    this.getLocalData()
  },
  methods: {
    async save() {
      try {
        const payload = this.toSnakeCase(this.form)
        await axios(this.$store.state.auth.token).post('/stock-brand-types', payload)
        this.reset()
        this.$emit('created')
        SuccessPopup.fire({
          title: 'Brand Type Created',
          text: 'The stock brand type has been successfully created.',
        })
      } catch (e) {
        if (e?.response?.data?.errors) {
          this.validationErrors = { ...e.response.data.errors }
          return
        }
        ErrorPopup.fire('Failed to create brand type.')
      }
    },
    storeToLocal() {
      localStore.set({
        createStockBrandType: {
          ...this.form,
          unsavedChanges: true,
        },
      })
    },
    getLocalData() {
      const saved = localStore.get('createStockBrandType')
      if (saved?.unsavedChanges) {
        this.form = { ...saved }
      }
    },
    reset() {
      this.form = defaultForm()
      this.validationErrors = {}
      localStore.delete('createStockBrandType')
    },
    toSnakeCase(obj) {
      return Object.keys(obj).reduce((acc, key) => {
        acc[camelToSnake(key)] = obj[key]
        return acc
      }, {})
    },
  },
}
</script>
